<form [formGroup]="fG">
  <ejs-checkbox [formControlName]="fCN" [labelPosition]="labelPosition" [value]="value" [label]="label" [checked]="checked" [cssClass]="cssClass + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? ' e-error' : '')"></ejs-checkbox>
  <ng-content />
</form>
